import { Link, Paragraph } from '@vimeo/iris/typography';

export default function Albums() {
  return (
    <div>
      <Paragraph size="2">
        A <em>showcase</em> (previously <em>album</em>) is a collection of videos for public or
        private sharing. When developing for this feature, keep in mind that our endpoint syntax
        uses the original <code>album</code> nomenclature, although this is subject to change in the
        future. For more information about showcases, see our{' '}
        <Link
          variant="minimal"
          href="https://vimeo.com/help/sso?redirect_to=https://help.vimeo.com/hc/en-us/articles/12426259177105-Showcases"
        >
          Help Center
        </Link>
        .
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
